import { useHomeDispatch } from './home-context';
import { ACTION_TYPES } from './home-reducer';
import PortalAppService from '../../../application/platform/portal-app-service';

export const useHomeController = () => {
  const HomeDispatch = useHomeDispatch();

  async function loadBanners() {
    try {
      HomeDispatch({ type: ACTION_TYPES.setLoading, payload: true });
      const bannersData = await PortalAppService.listBanners();
      // Lista vazia faz o BannerSlide exibir os banners institucionais
      HomeDispatch({ type: ACTION_TYPES.loadingBanners, payload: bannersData || [] });
    } catch (error) {
      console.error('Error loading banners:', error);
      HomeDispatch({ type: ACTION_TYPES.loadingBanners, payload: [] });
    }
  }

  /** limit: quantidade de notícias buscadas (a home customizada pode exibir até 20). */
  async function loadNews(limit: number = 4) {
    try {
      HomeDispatch({ type: ACTION_TYPES.setLoadingNews, payload: true });
      const newsData = await PortalAppService.listNewsLimit(limit);
      HomeDispatch({ type: ACTION_TYPES.loadingNews, payload: newsData.items || [] });
    } catch (error) {
      console.error('Error loading news:', error);
      HomeDispatch({ type: ACTION_TYPES.setErrorNews, payload: 'Não foi possível carregar as notícias' });
    }
  }

  async function loadGroupedDailyOfficial() {
    try {
      HomeDispatch({ type: ACTION_TYPES.setLoadingPublications, payload: true });
      const groupedData = await PortalAppService.listGroupedDailyOfficial();
      HomeDispatch({ type: ACTION_TYPES.setGroupedDailyOfficial, payload: groupedData });
    } catch (error) {
      console.error('Error loading grouped daily official:', error);
      HomeDispatch({ type: ACTION_TYPES.setLoadingPublications, payload: false });
    }
  }

  async function loadCategoriesWithSubcategories() {
    try {
      HomeDispatch({ type: ACTION_TYPES.setLoadingPublications, payload: true });
      const categoriesData = await PortalAppService.listCategoriesWithSubcategories();
      HomeDispatch({ type: ACTION_TYPES.setCategoriesWithSubcategories, payload: categoriesData });
    } catch (error) {
      console.error('Error loading categories with subcategories:', error);
      HomeDispatch({ type: ACTION_TYPES.setLoadingPublications, payload: false });
    }
  }

  function setActiveSlide(slideIndex: number) {
    HomeDispatch({ type: ACTION_TYPES.setActiveSlide, payload: slideIndex });
  }

  function setActiveNewsSlide(slideIndex: number) {
    HomeDispatch({ type: ACTION_TYPES.setActiveNewsSlide, payload: slideIndex });
  }

  function clearData() {
    HomeDispatch({ type: ACTION_TYPES.clearData });
  }

  return {
    loadBanners,
    loadNews,
    setActiveSlide,
    setActiveNewsSlide,
    clearData,
    loadGroupedDailyOfficial,
    loadCategoriesWithSubcategories,
  };
};
